var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"2.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }